import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './i18n'
import './styles/global.css'
import YandexMetrika from './YandexMetrika.jsx'

ReactDOM.createRoot(document.getElementById('root')).render(
    <BrowserRouter
        future={{
            v7_startTransition: true,
            v7_relativeSplatPath: true
        }}
    >
        <YandexMetrika />
        <App />
    </BrowserRouter>
)
